module.exports = (__webpack_require__(979))(7294);